/** ドコモユーザメニュ */
export const NAV_MENU_DOCOMO = [
  {
    id: 1,
    text: "GW事業者管理",
    permissions: [
      {
        id: "gw",
        items: [{ type: "link", text: "GW一覧", href: "/gateway-companies" }],
      },
    ],
  },
  {
    id: 2,
    text: "ホールディングス案件管理",
    permissions: [
      {
        id: "hd",
        items: [
          {
            type: "link",
            text: "ホールディングス案件一覧",
            href: "/holdings",
          },
        ],
      },
    ],
  },
  //! SP15表示メニューはまだなし
  // {
  //   text: "加盟店申請手続き",
  //   permissions: [],
  // },
  {
    id: 4,
    text: "審査業務",
    permissions: [
      {
        id: "examine",
        items: [
          {
            type: "link",
            text: "ID払い出し結果受領・取込（ShopID）",
            href: "/prior-payout/shop-ids",
          },
          {
            type: "link",
            text: "ID払い出し結果受領・取込（クレカ加盟店番号）",
            href: "/prior-payout/credit-card-merchant-numbers",
          },
          {
            type: "link",
            text: "審査申請回答登録",
            href: "/application-status/credit-card-examination-file",
          },
          {
            type: "link",
            text: "審査状況・POS登録状況照会",
            href: "/examination-status",
          },
          {
            type: "link",
            text: "Omni PG 切替",
            href: "/switch-payment-provider",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    text: "申請状況管理",
    permissions: [
      {
        id: "progress",
        items: [
          {
            type: "link",
            text: "申請状況照会",
            href: "/application-status",
          },
        ],
      },
      {
        id: "individual_counseling",
        items: [
          {
            type: "link",
            text: "個別取扱確認結果一覧",
            href: "/individual-handling-confirmation",
          },
        ],
      },
      {
        id: "apply_merchant_direct",
        items: [
          {
            type: "link",
            text: "加盟店回答状況登録",
            href: "/answered-application",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    text: "加盟店管理",
    permissions: [
      {
        id: "apply_company_read",
        items: [
          { type: "link", text: "加盟店一覧", href: "/merchants" },
          { type: "link", text: "入金口座一覧", href: "/bank-accounts" },
        ],
      },
      {
        id: "apply",
        items: [
          {
            type: "link",
            text: "店舗情報申請（直接）",
            href: "/store-direct-applications",
          },
          {
            type: "link",
            text: "加盟店情報申請（包括）",
            href: "/merchant/inclusion-application",
          },
          // step1　不要
          // {
          //   type: "link",
          //   text: "事業者情報確認・更新",
          //   href: "/merchant/direct-application/corporate-info/:regist",
          // },
        ],
      },
      {
        id: "apply_merchant_direct",
        items: [
          {
            type: "link",
            text: "加盟店情報申請（直接・ファイルアップロード）",
            href: "/merchant/alternative-direct-application",
          },
        ],
      },
      {
        id: "rate_setting",
        items: [
          {
            type: "link",
            text: "料率調整案件一覧",
            href: "/rate-adjustment-case-list",
          },
        ],
      },
      {
        id: "individual_counseling",
        items: [
          {
            type: "link",
            text: "個別相談案件一覧",
            href: "/individual-counseling-project",
          },
          {
            type: "link",
            text: "決済状態変更申請",
            href: "/settlement-state-change-application",
          },
        ],
      },
    ],
  },
  {
    id: 7,
    text: "アカウント管理",
    permissions: [
      {
        id: "account",
        items: [{ type: "link", text: "ユーザ管理", href: "/users" }],
      },
    ],
  },
  {
    id: 8,
    text: "設定",
    permissions: [
      {
        id: "master_edit",
        items: [
          {
            type: "link",
            text: "加盟店種別一覧",
            href: "/merchant-types",
          },

          {
            type: "link",
            text: "業態変換一覧",
            href: "/industry-conversions",
          },
          {
            type: "link",
            text: "通知マスタ一覧",
            href: "/notifications",
          },
          {
            type: "link",
            text: "申請様式一覧",
            href: "/application-form-list",
          },
          {
            type: "link",
            text: "環境依存文字マッピング",
            href: "/dependence-character",
          },
          {
            type: "link",
            text: "NG名称定義",
            href: "/ngname",
          },
          {
            type: "link",
            text: "旅行業登録者定義",
            href: "/tourist-industry",
          },
        ],
      },
      {
        id: "apply_merchant_direct",
        items: [
          {
            type: "link",
            text: "代替申請-変換ツール",
            href: "/conversion-tool",
          },
        ],
      },
    ],
  },
  //! SP15表示メニューはまだなし
  // {
  //   id: 9,
  //   text: "システム管理",
  //   permissions: [],
  // },
  // SSO連携用
  {
    id: 10,
    text: "サービス運用・精算",
    permissions: [
      {
        id: "neo_connection_info",
        items: [
          {
            type: "link",
            text: "接続情報管理",
            href: "/sso?mnId=0000000041",
          },
        ],
      },
      {
        id: "neo_sales",
        items: [
          {
            type: "link",
            text: "売上管理",
            href: "/sso?mnId=0000000049",
          },
        ],
      },
      {
        id: "neo_file_download",
        items: [
          {
            type: "link",
            text: "ダウンロードファイル予約",
            href: "/sso?mnId=0000000045",
          },
          {
            type: "link",
            text: "ダウンロードファイル管理",
            href: "/sso?mnId=0000000047",
          },
        ],
      },
      {
        id: "neo_reimbursement",
        items: [
          {
            type: "link",
            text: "精算管理",
            href: "/sso?mnId=0000000043",
          },
        ],
      },
      {
        id: "neo_response_setting",
        items: [
          {
            type: "link",
            text: "その他機能",
            href: "/sso?mnId=0000000054",
          },
        ],
      },
    ],
  },
  {
    id: 11,
    text: "コミュニケーション等",
    permissions: [
      {
        id: "neo_no_restriction",
        items: [
          {
            type: "link",
            text: "ドキュメント一覧",
            href: "/sso?mnId=0000000030",
          },
          {
            type: "link",
            text: "お問い合わせ一覧",
            href: "/sso?mnId=0000000031",
          },
          {
            type: "link",
            text: "お知らせ一覧",
            href: "/sso?mnId=0000000032",
          },
        ],
      },
    ],
  },
];
